import { TextInput } from "react-admin";
import { alphanumericWordsValidator } from "../../validators";

export const OrganForm = () => (
	<>
		<TextInput source="name" validate={alphanumericWordsValidator} fullWidth />
		<TextInput
			source="abbreviation"
			validate={alphanumericWordsValidator}
			fullWidth
		/>
	</>
);
